var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyOfficesHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10H13V8H11V10ZM11 14H13V12H11V14ZM13 20V16H11V20H8V7H11H13H16V20H13ZM20 18V20H18V5H16H13V2H11V5H8H6V20H4V18H2V20V22H6H8H16H18H22V20V18H20Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOfficesHeaderIcon);
export default __webpack_public_path__ + "static/media/my_offices_header_icon.e018adf76da2bfae4dc94b1cab523214.svg";
export { ForwardRef as ReactComponent };